import { createContext, useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

type RouteHistoryContextType = {
  history: string[];
};

const RouteHistoryContext = createContext<RouteHistoryContextType>({
  history: [],
});

export const RouteHistoryProvider = ({ children }: any) => {
  const location = useLocation();

  const historyRef = useRef<string[]>([]);

  useEffect(() => {
    const path = location.pathname;

    const last = historyRef.current[historyRef.current.length - 1];

    if (last !== path) {
      historyRef.current.push(path);
    }
  }, [location.pathname]);

  return (
    <RouteHistoryContext.Provider value={{ history: historyRef.current }}>
      {children}
    </RouteHistoryContext.Provider>
  );
};

export const useRouteHistory = () => useContext(RouteHistoryContext);
